

import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { Chart } from "react-google-charts";

// Material components
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

// Component styles
import { api_host, api_auth } from '../../../../../common/globals/constants';
import moment from 'moment'
import 'moment/locale/es'
import { TableCell } from '@material-ui/core';
moment.locale('es')


class Trend extends Component {
    
    constructor(props) {
        //console.log("trend")
        super(props);
        //console.log(this.props)
        this.state = {
            isLoad:true,
            user:sessionStorage.getItem("user"),
            token:sessionStorage.getItem("key"),
            objective:this.props.data.objetivo_id,
            series:[],
        };

    }
    
    componentDidMount() {
        //console.log(this.state)
        //this.processData();
        this.getData();
    }

    getData(){
        const {user, token, objective}=this.state
        fetch(api_host+`/reporte/online/indicadores/AvailabilityHour/?user=${user}&objetiveId=${objective}&t=d&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
                .then(response => response.json())
                .then(myJson => {
                    //console.log(myJson)
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson)
                            
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

    }

   
    processData = (externalData) => {
        let chartDataUptime = []
        //console.log(externalData.nombre_objetivo)
        //console.log(externalData.data_pasos[0].data.length)
        externalData.data_pasos[0].data.forEach((dataDate, forEachKey) => {
            let dateJson = (new Date(dataDate.desde))
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()
            if(forEachKey!==externalData.data_pasos[0].data.length){
                var uptime = dataDate.data[0].uptime+dataDate.data[0].parcial
                chartDataUptime.push([Date.UTC(year, (month), day, hours, minutes, seconds), parseFloat(uptime)])
            }
            
            
        })
        chartDataUptime.unshift(["tiempo", "disponibilidad"])
        this.setState({
            series: chartDataUptime,
            dataError: false,
            isLoad: false,
        });

    }
    render() {

        const { isLoad, series} = this.state;
        const { classes } = this.props;
        if (isLoad===true) {
            return(
                <TableCell className={classes.td} >
    
                         <CircularProgress
                          variant="indeterminate"
    
                          size={12}
                          thickness={4}
                          
                        />
                </TableCell>
            )
        }else{
            return(
                <FormattedChart chartOptions={series} /> 
            )
        }
        
        
    }
}
function FormattedChart(props) {
    const options = {
        chartArea: {
            left: 40
          },
        enableInteractivity: false,
        title: "",
        //curveType: "function",
        hAxis: {
            lineColor: '#e4dede',
            ticks: []
        },
        /*vAxis: {
            //baselineColor: 'none',
            ticks: []
        },*/
        vAxis: { 
            gridlines: { count: 2 },
            maxValue:100,
            minValue:0
        },
        'tooltip' : {
            trigger: 'none'
          },
        legend: 'none'
      };
    return (
        
        <Chart
          chartType="AreaChart"
          data={props.chartOptions}
          width="100%"
          height="70px"
          options={options}
          legendToggle
        />
       
    )
}



export default compose(withRouter, withStyles(styles))(Trend);